@if(guestScreeningService.loading$ | async) {
    <div class="d-flex justify-content-center mt-5 w-100">
        <mat-spinner></mat-spinner>
    </div>
} @else {
    <main class="d-flex align-items-start min-vh-100 py-3 py-md-0 pb-5 mb-5">
        <div class="container card card-container">
            <div class="col-sm-12 col-md-10 col-lg-9 mx-auto mt-4">
                <h1>Screen a Guest</h1>
                <br>
                <app-terms-and-conditions></app-terms-and-conditions>
                <form [formGroup]="guestForm" *ngIf="guestForm">
                    <div class="form-container">
                        <div class="full-width my-3">
                            <strong>Guest Information:</strong>
                        </div>
                        <mat-form-field class="full-width" hideRequiredMarker appearance="outline">
                            <mat-label>Organization<span class="required-input">*</span></mat-label>
                            <input type="text"
                                placeholder="Select Organization"
                                matInput
                                [formControl]="orgControl"
                                [matAutocomplete]="auto">
                                <mat-error *ngIf="orgControl.invalid">
                                    Please select a valid Organization
                                </mat-error>
                            <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" (optionSelected)="onOrgSelectionChanged($event)" [displayWith]="displayOrgFn">
                                <mat-option *ngFor="let organization of filteredOrganizations | async" [value]="organization">
                                    {{ organization.organization_name }}
                                </mat-option>
                            </mat-autocomplete>
                        </mat-form-field>
                        <mat-form-field class="full-width" hideRequiredMarker appearance="outline">
                            <mat-label>First Name <span class="red">*</span> </mat-label>
                            <input type="text" matInput placeholder="First Name" formControlName="firstName">
                            <mat-error *ngIf="guestForm.controls['firstName'].invalid">Required</mat-error>
                        </mat-form-field>
                        <mat-form-field class="half-width" hideRequiredMarker appearance="outline">
                            <mat-label>Middle Name <span class="red">*</span></mat-label>
                            <input type="text" matInput placeholder="Middle Name" formControlName="middleName"
                                [required]="!guestForm.controls['middleNameNotGiven'].value">
                            <mat-error *ngIf="guestForm.controls['middleName'].invalid">Required</mat-error>
                        </mat-form-field>
                        <mat-checkbox class="half-width px-2" *ngIf="!(guestForm.controls['middleName'].value.length > 0)"
                            formControlName="middleNameNotGiven" (change)="middleNameToggled.emit($event.checked)">
                            <span>
                                I certify the guest did not provide a middle name.
                            </span>
                        </mat-checkbox>
                        <mat-form-field class="full-width" hideRequiredMarker appearance="outline">
                            <mat-label>Last name <span class="red">*</span> </mat-label>
                            <input type="text" matInput placeholder="Last Name" formControlName="lastName">
                            <mat-error *ngIf="guestForm.controls['lastName'].invalid">Required</mat-error>
                        </mat-form-field>
                        <mat-form-field class="full-width" hideRequiredMarker appearance="outline">
                            <mat-label>Birthdate <span class="red">*</span> </mat-label>
                            <input matInput 
                                [matDatepicker]="picker" 
                                [max]="guestScreeningService.maxAgeRestriction" 
                                [min]="guestScreeningService.minAgeRestriction" 
                                formControlName="birthDate">
                            <mat-hint>Guest to screen must be at least 18 years old.</mat-hint>
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker startView="multi-year"></mat-datepicker>
                            <mat-error *ngIf="guestForm.controls['birthDate'].invalid">Invalid Date</mat-error>
                        </mat-form-field>
                        <mat-form-field class="full-width" appearance="outline">
                            <mat-label>Email</mat-label>
                            <input type="email" matInput placeholder="Email" formControlName="email">
                            <mat-error *ngIf="guestForm.controls['email'].invalid">Invalid Email</mat-error>
                        </mat-form-field>
                        <div *ngIf="guestScreeningService.countryCode$.value">
                            <mat-form-field class="full-width" hideRequiredMarker appearance="outline">
                                <mat-label>Phone Number <span class="red">*</span> </mat-label>
                                <input type="tel" matInput placeholder="Phone Number" formControlName="phoneNumber" (input)="phoneNumberChanged.emit($event)">
                                <mat-hint>Ex: {{ guestScreeningService.phoneNumberFormat$.value }}</mat-hint>
                                <mat-error *ngIf="guestForm.controls['phoneNumber'].invalid">Required | Ex: {{ guestScreeningService.phoneNumberFormat$.value }}</mat-error>
                            </mat-form-field>
                            <div class="full-width my-3"><strong>Home/Residence Address:</strong></div>
                            <mat-form-field class="full-width" hideRequiredMarker appearance="outline">
                                <mat-label>Address Line 1 <span class="red">*</span> </mat-label>
                                <input type="text" matInput placeholder="Address Line 1" formControlName="addressLine1">
                                <mat-error *ngIf="guestForm.controls['addressLine1'].invalid">Required</mat-error>
                            </mat-form-field>
                            <mat-form-field class="full-width" appearance="outline">
                                <mat-label>Address Line 2</mat-label>
                                <input type="text" matInput placeholder="Address Line 2" formControlName="addressLine2">
                            </mat-form-field>
                            <mat-form-field class="full-width" hideRequiredMarker appearance="outline">
                                <mat-label>City <span class="red">*</span> </mat-label>
                                <input type="text" matInput placeholder="City" formControlName="city">
                                <mat-error *ngIf="guestForm.controls['city'].invalid">Required</mat-error>
                            </mat-form-field>
                            <div class="col d-flex flex-column">
                                <mat-form-field appearance="outline" hideRequiredMarker>
                                    <mat-label>State<span class="red"> * </span></mat-label>
                                    <mat-select formControlName="state">
                                        <mat-option *ngFor="let state of guestScreeningService.states$ | async" [value]="state.value">{{ state.label }}</mat-option>
                                    </mat-select>
                                    <mat-error *ngIf="!guestForm.get('state')?.invalid">Required</mat-error>
                                </mat-form-field>
                            </div>
                            <mat-form-field class="full-width" hideRequiredMarker appearance="outline">
                                <mat-label>Zip / Postal Code <span class="red">*</span> </mat-label>
                                <input matInput #postalCode placeholder="Postal Code" formControlName="postalCode">
                                <mat-error *ngIf="guestForm.controls['postalCode'].invalid">Required</mat-error>
                            </mat-form-field>
                            <div class="text-muted">
                                We are unable to screen guests who live outside of the United States. For questions regarding the requirements of your reservation, please make sure to reach out to the property manager directly.
                            </div>
                        </div>
                    </div>
                    <div class="my-4 d-flex justify-content-end">
                        <button mat-raised-button class="cancel-button" routerLink="/guests">
                            <mat-icon>cancel</mat-icon>
                            Cancel
                        </button>
                        <button mat-raised-button class="action-button" [disabled]="organizationSelectId === 0 || !guestForm.valid || guestFormInvalid" (click)="guestScreeningService.submit()">
                            <mat-icon>check</mat-icon>
                            Screen Now
                        </button>
                    </div>
                    <hr>
                    <div *ngIf="guestFormInvalid" class="d-flex justify-content-end align-items-center text-muted">
                        <span class="red">*</span>&nbsp;- Organization has no verification package assigned
                    </div>
                    <mat-action-row class="mt-3 d-flex justify-content-end">
                        <div class="d-flex justify-content-end align-items-center text-muted">
                            <span class="red">*</span>&nbsp;- Required fields
                        </div>
                    </mat-action-row>
                </form>
            </div>
        </div>
    </main>
}